export const LOCK_LEVELS = [
  { value: 0, label: 'Unlocked' },
  { value: 1, label: 'Lock MODE' },
  { value: 2, label: 'Lock FAN + MODE' },
  { value: 3, label: 'Lock all but POWER' },
  { value: 4, label: 'Lock all' },
];

export const LOCK_LABELS = LOCK_LEVELS.reduce((acc, option) => {
  acc[option.value] = option.label;
  return acc;
}, {});

const clampLockValue = value => {
  if (!Number.isFinite(value)) return 0;
  if (value < 0) return 0;
  if (value > 4) return 4;
  return Math.trunc(value);
};

export const normalizeLockValue = value => {
  if (typeof value === 'number') {
    return clampLockValue(value);
  }

  if (typeof value === 'boolean') {
    return value ? 4 : 0;
  }

  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (trimmed === '') return 0;

    const numeric = Number(trimmed);
    if (!Number.isNaN(numeric)) {
      return clampLockValue(numeric);
    }

    const lower = trimmed.toLowerCase();
    if (lower === 'on') return 4;
    if (lower === 'off') return 0;

    const matchedLevel = LOCK_LEVELS.find(level => level.label.toLowerCase() === lower);
    if (matchedLevel) {
      return matchedLevel.value;
    }
  }

  return 0;
};
